
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

import ImageView from "@/components/ImageView.vue";

import TestQuestionVersion from "@/models/unit/unitable/test/question_version";

@Component({
  name: "CSubscriptionUnitTestQuestion",
  components: {
    ImageView
  }
})
export default class CSubscriptionUnitTestQuestion extends Vue {
  @Prop({ required: true }) private question_version!: TestQuestionVersion;

  public answer_id: string = "";
  public answer_ids: string[] = [];

  @Watch("question_version")
  protected changeQuestionVersion() {
    this.answer_id = "";
    this.answer_ids = [];

    this.question_version.answer_versions.forEach(av => {
      av.is_selected = false;
    });
  }

  public nextQuestion() {
    if (this.question_version.question.type === "SINGLE") {
      this.$emit("nextQuestion", [this.answer_id]);
    } else {
      this.$emit("nextQuestion", this.answer_ids);
    }
  }
}
